// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__KY7h8","loaderContainer":"Loader_loaderContainer__xJ89f"};